var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAward = function SvgAward(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55005 9.18353V13.3252C3.55005 14.8419 3.55005 14.8419 4.98338 15.8085L8.92505 18.0835C9.51672 18.4252 10.4834 18.4252 11.075 18.0835L15.0167 15.8085C16.45 14.8419 16.45 14.8419 16.45 13.3252V9.18353C16.45 7.66686 16.45 7.66686 15.0167 6.7002L11.075 4.4252C10.4834 4.08353 9.51672 4.08353 8.92505 4.4252L4.98338 6.7002C3.55005 7.66686 3.55005 7.66686 3.55005 9.18353Z",
    stroke: "#EE5A8A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 6.35817V4.1665C14.5834 2.49984 13.7501 1.6665 12.0834 1.6665H7.91675C6.25008 1.6665 5.41675 2.49984 5.41675 4.1665V6.29984",
    stroke: "#EE5A8A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.525 9.1583L11 9.89997C11.075 10.0166 11.2416 10.1333 11.3666 10.1666L12.2166 10.3833C12.7416 10.5166 12.8833 10.9666 12.5416 11.3833L11.9833 12.0583C11.9 12.1666 11.8333 12.3583 11.8416 12.4916L11.8916 13.3666C11.925 13.9083 11.5416 14.1833 11.0416 13.9833L10.225 13.6583C10.1 13.6083 9.89165 13.6083 9.76665 13.6583L8.94998 13.9833C8.44998 14.1833 8.06665 13.9 8.09998 13.3666L8.14998 12.4916C8.15831 12.3583 8.09165 12.1583 8.00831 12.0583L7.44998 11.3833C7.10831 10.9666 7.24998 10.5166 7.77498 10.3833L8.62498 10.1666C8.75831 10.1333 8.92498 10.0083 8.99165 9.89997L9.46665 9.1583C9.76665 8.7083 10.2333 8.7083 10.525 9.1583Z",
    stroke: "#EE5A8A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "award.2b915240fc4b753561e817cac166bfbf.svg";